import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect, useState } from "react";
import Emitter from "../common/emitter";
import { UserInfo } from "../common/interfaces";

const HandleUserLogin = () => {
	const { authState, oktaAuth } = useOktaAuth();
	const [userInfo, setUserInfo] = useState<UserInfo>({ name: "", groups: [] });

	useEffect(() => {
		Emitter.on("logout", () => {
			oktaAuth.signOut();
		});
		// should not be called on oktaAuth value change
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!userInfo.name && authState.accessToken) {
			oktaAuth.getUser().then((info: UserInfo) => {
				// store user info in session context
				setUserInfo(info);
				Emitter.emit("setSessionDetail", {
					accessToken: authState.accessToken,
					userInfo: info,
				});
				localStorage.setItem("okta-user-info", JSON.stringify(info));
			});
		}
	}, [authState.accessToken, oktaAuth, userInfo.name, userInfo.groups]);

	return <></>;
};
export default HandleUserLogin;
